<style scoped>
.meeting-box {
  margin: 16px 10px;
  padding: 5px 20px;
  background: #fff;
  border-radius: 4px;
  text-align: left;
}
.meeting-subject {
  font-size: 20px;
  /* font-weight: bold; */
}
.information-box {
  display: flex;
  justify-content: space-between;
  overflow: hidden;
}
.information-list {
  /* width: 33%; */
}
.state-now {
  border: 1px solid grey;
}
.now-state {
  font-size: 14px;
  padding: 5px 30px;
  border-radius: 4px;
  cursor: pointer;
  border: 1px solid grey;
}
.video-url {
  color: #4fa1a4;
  margin-left: 15px;
  text-decoration: underline;
  cursor: pointer;
}
.box-left {
  width: 40%;
  height: 350px;
  padding: 0 20px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
  overflow-y: auto;
}
.box-right {
  width: 57%;
  height: 350px;
  padding: 0 10px 20px 10px;
  border: 1px solid #bbb;
  box-sizing: border-box;
}
.management {
  padding: 0 50px;
}
.list-textarea {
  flex: 1;
}
.management-list {
  display: flex;
  align-items: center;
  /* margin-bottom: 15px; */
}
.select-department {
  color: green;
  text-decoration: underline;
  cursor: pointer;
}
.management-name {
  flex-shrink: 0;
}
.designee {
  padding: 3px 10px 6px 10px;
  display: inline-block;
  border: 1px solid grey;
  box-sizing: border-box;
  line-height: 20px;
  margin-right: 10px;
}
.input-item {
  display: flex;
  align-items: center;
  margin-left: 20px;
  margin-bottom: 25px;
}
.input-item .input-title {
  margin-right: 14px;
}
</style>
<template>
  <div class="meeting-detail pb30">
    <div class="meeting-box">
      <p class="meeting-subject">
        会议主题：{{ onlineDetail.meetingSubject }} <span class="ml30 fontC-red">{{ $route.query.meetingState }}</span
        ><span class="now-state state-back fr" @click="$router.go(-1)">返回</span
        ><span class="now-state state-back fr" style="margin-right: 10px" v-if="listType == 2" @click="detailModify"
          >资料修改</span
        >
      </p>
      <p class="font-S16">所属公司：{{ $route.query.tenantName }}</p>
    </div>
    <div class="meeting-box">
      <p class="font-S16">基本信息</p>
      <div class="information-box">
        <div class="information-list">
          <p><span class="fontC-bbb">会议发起人：</span>{{ onlineDetail.staffName }}</p>
          <p><span class="fontC-bbb">会议开始时间：</span>{{ onlineDetail.startTime | getTime }}</p>
          <p>
            <span class="fontC-bbb">安全级别：</span><span v-if="onlineDetail.safeLevel == 1">低（无限制）</span
            ><span v-if="onlineDetail.safeLevel == 2">中（参会人需输入密码、短信验证）</span
            ><span v-if="onlineDetail.safeLevel == 3">高（参会人需输入密码、短信验证、无法下载会议）</span>
          </p>
          <p>
            <span class="fontC-bbb" v-if="onlineDetail.meetingAddress">会议地点：</span
            ><span>{{ onlineDetail.meetingAddress }}</span>
          </p>
          <p>
            <span class="fontC-bbb" v-if="onlineDetail.serviceCompany">推广服务商：</span
            ><span>{{ onlineDetail.serviceCompany }}</span>
          </p>
        </div>
        <div class="information-list w25f">
          <p><span class="fontC-bbb">提交日期：</span>{{ onlineDetail.createTime | getTime }}</p>
          <p><span class="fontC-bbb">会议结束时间：</span>{{ onlineDetail.endTime | getTime }}</p>
          <p><span class="fontC-bbb">会议负责人：</span>{{ onlineDetail.leader }} {{ onlineDetail.leaderMobileNo }}</p>
          <p>
            <span class="fontC-bbb">会议费用(元)：</span
            ><span>{{ onlineDetail.meetingCost }}</span>
          </p>
        </div>
        <div class="information-list">
          <p>
            <span class="fontC-bbb">会议类型：</span
            ><span v-if="onlineDetail.meetingType == 1">小型（单讲者会议 + 会议50人以内）</span
            ><span v-if="onlineDetail.meetingType == 2">中型（单讲者会议 + 会议100人以内）</span
            ><span v-if="onlineDetail.meetingType == 3">大型（多讲者会议 + 会议100人以上）</span>
            <span v-if="$route.query.isMeetingApply == 'N'">{{onlineDetail.meetingType}}</span>
          </p>
          <p><span class="fontC-bbb">会议时长(分钟)：</span>{{ $route.query.meetingTimeLong }}</p>
          <p>
            <span class="fontC-bbb">参会人数(人)：</span
            >{{
              onlineDetail.peopleNum !== 0 && onlineDetail.peopleNum !== '' && onlineDetail.peopleNum !== null
                ? onlineDetail.peopleNum
                : '-'
            }}
          </p>
          <p>
            <span class="fontC-bbb" v-if="onlineDetail.serviceStaff">推广服务人员：</span
            ><span>{{ onlineDetail.serviceStaff }}</span>
          </p>
        </div>
      </div>
    </div>
    <div class="meeting-box" v-if="onlineDetail.meetingPlan">
      <p class="font-S16">会议方案</p>
      <p>{{ caCodeToDesc(onlineDetail.meetingPlan) }}</p>
    </div>
    <div class="meeting-box" v-if="onlineDetail.meetingAgenda">
      <p class="font-S16">会议议程</p>
      <p>{{ onlineDetail.meetingAgenda }}</p>
    </div>
    <div class="meeting-box" v-if="onlineDetail.meetingPrupose">
      <p class="font-S16">会议目的</p>
      <p>{{ onlineDetail.meetingPrupose }}</p>
    </div>
    <div class="meeting-box" v-if="onlineDetail.desiredResult">
      <p class="font-S16">预期效果</p>
      <p>{{ onlineDetail.desiredResult }}</p>
    </div>
    <div class="meeting-box" v-if="onlineDetail.speakerIntroduction">
      <p class="font-S16">讲者介绍</p>
      <p>{{ onlineDetail.speakerIntroduction }}</p>
    </div>
    <div class="meeting-box pb20">
      <p class="font-S16">会议信息</p>
     <p>
        <template v-if="$route.query.isMeetingApply =='N'&&onlineDetail.meetingUrl">
          <span class="fontC-bbb">链接： </span>{{ onlineDetail.meetingUrl }}
          <span v-show="onlineDetail.meetingUrl" @click="toLink(onlineDetail.meetingUrl)" class="video-url">查看</span>
        </template>
        <template v-if="$route.query.isMeetingApply =='Y'&&onlineDetail.videoUrl"
          ><span class="fontC-bbb">腾讯链接：</span>{{ onlineDetail.videoUrl }}
          <span @click="toLink(onlineDetail.videoUrl)" class="video-url">查看会议视频</span>
        </template>
      </p>
      <div class="information-box">
        <div class="information-list w30f">
          <span class="fontC-bbb">客服热线：</span>{{ onlineDetail.servicePhone }}
        </div>
        <div class="information-list w70f">
          <span class="fontC-bbb">实际参会人数：</span>{{ onlineDetail.realJoinNum }} 人
        </div>
      </div>
    </div>
    <div class="meeting-box" v-if="billList && billList.length != 0">
      <p class="font-S16">会议海报/邀请函照片</p>
      <el-image
        v-for="(item, index) in billList"
        :key="index"
        style="width: 100px; height: 100px; margin-right: 20px"
        :src="item"
        :preview-src-list="billList"
      >
      </el-image>
      <p class="fontC-bbb" v-if="billList == null || billList == ''">暂无图片</p>
    </div>
    <div class="meeting-box" v-if="imgList && imgList.length != 0">
      <p class="font-S16">会议照片</p>
      <el-image
        v-for="(item, index) in imgList"
        :key="index"
        style="width: 100px; height: 100px; margin-right: 20px"
        :src="item"
        :preview-src-list="imgList"
      >
      </el-image>
      <p class="fontC-bbb" v-if="imgList == null || imgList == ''">暂无图片</p>
    </div>
    <div class="meeting-box" v-if="signList && signList.length != 0">
      <p class="font-S16">签到表</p>
      <el-image
        v-for="(item, index) in signList"
        :key="index"
        style="width: 100px; height: 100px; margin-right: 20px"
        :src="item"
        :preview-src-list="signList"
      >
      </el-image>
      <p class="fontC-bbb" v-if="signList == null || signList == ''">暂无图片</p>
    </div>
    <div class="meeting-box" v-if="meetingReport && meetingReport.length != 0">
      <p class="font-S16">会议报告</p>
      <el-image
        v-for="(item, index) in meetingReport"
        :key="index"
        style="width: 100px; height: 100px; margin-right: 20px"
        :src="item"
        :preview-src-list="meetingReport"
      >
      </el-image>
      <p class="fontC-bbb" v-if="meetingReport == null || meetingReport == ''">暂无图片</p>
    </div>

    <el-dialog title="会后资料修改" :visible.sync="afterMeetingVisible" width="70%">
      <el-form label-width="100px" class="demo-ruleForm">
        <el-form-item label="会议照片:">
          <el-upload
            action="#"
            name="image"
            class="fl"
            list-type="picture-card"
            :headers="token"
            :file-list="meetingPhotoList"
            :on-remove="handleMeetingRemove"
            :http-request="uploadMeetingImage"
          >
            <i slot="default" class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="签到表:">
          <el-upload
            action="#"
            name="image"
            class="fl"
            list-type="picture-card"
            :headers="token"
            :file-list="signFileList"
            :on-remove="handleSignRemove"
            :http-request="uploadSignImage"
          >
            <i slot="default" class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="实际参会人数">
          <el-input type="input" class="w420 fl" v-model="afterPage.realJoinNum"> </el-input>
        </el-form-item>
        <el-form-item label="回放链接">
          <el-input type="input" class="w420 fl" placeholder="请填写回放链接" v-model="afterPage.videoUrl"> </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" plain @click="afterMeetingVisible = false">取 消</el-button>
        <el-button size="medium" type="info" @click="sureAfterUpdate" v-loading.fullscreen.lock="fullscreenLoading"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <el-dialog title="会前资料修改" :visible.sync="beforeMeetingVisible" width="70%">
      <el-form label-width="100px" label-position="center" class="demo-ruleForm">
        <div class="input-item">
          <div class="input-title"><span class="fontC-red">*</span><span>选择平台</span></div>
          <el-select class="w420 fl" v-model="beforePage.meetingPlatformGuid" placeholder="请选择平台">
            <el-option
              v-for="item in platformList"
              :key="item.guid"
              :label="item.platformName"
              :value="item.guid"
            ></el-option>
          </el-select>
        </div>
        <div class="input-item">
          <div class="input-title"><span class="fontC-red">*</span><span>会议报名</span></div>
          <el-radio-group v-model="beforePage.isNeedRegister">
            <el-radio label="Y">需要</el-radio>
            <el-radio label="N">不需要</el-radio>
          </el-radio-group>
        </div>
        <el-form-item label="邀请海报">
          <el-upload
            action="#"
            name="image"
            class="fl"
            list-type="picture-card"
            :headers="token"
            :limit="1"
            :on-exceed="handleExceed"
            :file-list="meetingBillList"
            :on-remove="handleBillRemove"
            :http-request="uploadBillImage"
          >
            <i slot="default" class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="会议封面">
          <el-upload
            action="#"
            name="image"
            class="fl"
            list-type="picture-card"
            :headers="token"
            :file-list="meetingLogoList"
            :on-remove="handleLogoRemove"
            :http-request="uploadLogoImage"
          >
            <i slot="default" class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>

        <div class="input-item">
          <div class="input-title"><span class="fontC-red">*</span><span>客服热线</span></div>
          <el-input class="w420 fl" type="input" placeholder="请填写客服热线" v-model="beforePage.servicePhone">
          </el-input>
        </div>
        <div class="input-item">
          <div class="input-title"><span class="fontC-red">*</span><span>会议编号</span></div>
          <el-input class="w420 fl" type="input" placeholder="请填写会议编号" v-model="beforePage.meetingNo">
          </el-input>
        </div>
        <div class="input-item">
          <div class="input-title"><span class="fontC-red">*</span><span>会议链接</span></div>
          <el-input class="w420 fl" type="input" placeholder="请填写会议链接" v-model="beforePage.meetingUrl">
          </el-input>
        </div>
        <div class="management-list" style="margin-left: 28px">
          <div class="management-name">会议可见部门：</div>
          <div>
            <span
              class="designee mb10"
              v-show="departmentData !== '' || departmentData !== null"
              v-for="(item, index) in departmentData"
              :key="index"
              ><span class="select-name">{{ item.organisationName }}</span>
              <span @click="delDepartmentSingle(index)" class="ml10 cursor-sty font-S19">×</span></span
            >
            <span class="select-department" @click="visible3 = true">{{
              departmentData && departmentData.length > 0 ? '修改' : '选择部门'
            }}</span>
          </div>
        </div>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="medium" plain @click="beforeMeetingVisible = false">取 消</el-button>
        <el-button size="medium" type="info" @click="sureBeforeUpdate" v-loading.fullscreen.lock="fullscreenLoading"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog title="选择部门" :visible.sync="visible3" width="70%" center>
      <div>
        <div class="select-box">
          <div class="box-left fl">
            <el-input v-model="filterText" class="ipt-sty mt15" placeholder="请输入部门名称"></el-input>
            <p class="fontC-bbb">组织架构</p>
            <el-tree
              class="filter-tree"
              :data="areaData"
              :props="defaultProps"
              :filter-node-method="filterNode"
              @node-click="handleNodeClick1"
              ref="tree"
            >
            </el-tree>
          </div>
          <div class="box-right fr">
            <p class="fontC-bbb fl">已选{{ departmentList.length }}个部门</p>
            <el-button size="medium" type="danger" @click="delDepartment()" class="fr" style="margin-top: 5px"
              >批量删除</el-button
            >
            <el-table
              :data="departmentList"
              v-loading="tableLoading"
              border
              height="280px"
              style="width: 100%"
              @selection-change="handleSelectionChange1"
            >
              <el-table-column type="selection" width="55"> </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                show-overflow-tooltip
                prop="organisationName"
                label="名称"
              >
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer t-right">
        <el-button plain size="medium" @click="visible3 = false">取消</el-button>
        <el-button size="medium" type="info" @click="departmentSure()">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { route } from '@/api/apiRoute';
export default {
  data() {
    return {
      fullscreenLoading: false,

      onlineDetail: '',
      approvalSuggest: '',
      flowName: '线上会议执行2',
      carbonName: '',
      approvalList: [],
      approverGuid: '',
      staffGuid: '',
      billList: [], //海报
      imgList: [], //照片
      signList: [], //签到表
      meetingReport: [],
      url: '',
      tenantName: '',
      flowType: '00002',
      meetingPlanList: [], //方案

      meetingStartState: '',
      listType: '',
      url: `/${serverConfig.msCommonAdminCloudService}/obs/upload-file`,
      urlImg: `/${serverConfig.msCommonAdminCloudService}/obs/upload-image`,
      token: {
        'Content-Type': 'multipart/form-data',
        Authorization: localStorage.token,
      },

      afterMeetingVisible: false,
      meetingPhotoList: [],
      signFileList: [],
      afterPage: {
        videoUrl: '',
        realJoinNum: '',
        signFile: [],
        meetingPhoto: [],
      },

      beforeMeetingVisible: false,
      platformList: [],
      meetingBillList: [], //海报
      meetingLogoList: [], //封面
      beforePage: {
        meetingBill: [],
        meetingLogo: [],
        meetingUrl: '', //会议链接
        servicePhone: '', //客服热线
        isNeedRegister: 'Y', //是否需要报名
        meetingPlatformGuid: '', //平台id
        meetingPlatformName: '', //平台名称
        meetingNo: '', //会议编号
      },

      tableLoading: false,
      visible3: false,
      area: [],
      departmentList: [],
      departmentData: '',
      areaData: [],
      delList: [],
      filterText: '',
      defaultProps: {
        id: 'guid',
        label: 'organisationName',
        children: 'children',
      },
    };
  },
  created() {
    let userinfo = JSON.parse(localStorage.userInfo);
    this.staffGuid = userinfo.staffGuid;
    this.meetingStartState = this.$route.query.meetingStartState;
    this.listType = this.$route.query.listType;
    this.getMeetingCaList();
  },
  methods: {
    getLink(url) {
      if (url) {
        return url.match(/[a-zA-z]+:\/\/[^\s]*/gi)[0];
      } else {
        return '';
      }
    },
    getPlatform() {
      let self = this;
      let page = {
        pageIndex: 1,
        pageSize: -1,
        isOpen: '1',
        platformUse: 0,
      };

      self.api.postJson(`/${serverConfig.msSalesPerformService}/meeting/platform/get-list`, page).then((res) => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.platformList = res.data.data.records;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getMeetingCaList() {
      var self = this;
      var page = {
        pageIndex: 1,
        pageSize: -1,
        isOpen: '-1',
      };
      self.api.postJson(`/${serverConfig.msSalesPerformService}/meeting/plan/get-list`, page).then((res) => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.meetingPlanList = res.data.data.records;
          self.getPlatform();
          self.getData();
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    caCodeToDesc(listStr) {
      var list = [];
      if (listStr != '') {
        list = JSON.parse(listStr);
        return list.join('；');
      }
    },

    toLink(URL) {
      window.open(URL);
    },
    getData() {
      let self = this;
      self.api
        .postCan(
          `/${serverConfig.msSalesPerformService}/flow/data/get-online-meeting-detail?guid=` + self.$route.query.guid,
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.getOrganisation(res.data.data.tenantGuid);
            self.onlineDetail = res.data.data;
            self.billList = [];
            self.imgList = [];
            self.signList = [];
            self.meetingReport = [];
            if (res.data.data.meetingBill !== null) {
              let meetingBill = JSON.parse(res.data.data.meetingBill);
              meetingBill.forEach((item) => {
                self.billList.push(item.path);
              });
              console.log(self.imgList);
            }
            if (res.data.data.meetingPhoto !== null) {
              let meetingPhoto = JSON.parse(res.data.data.meetingPhoto);
              meetingPhoto.forEach((item) => {
                self.imgList.push(item.path);
              });
              console.log(self.imgList);
            }
            if (res.data.data.signFile !== null) {
              let signFile = JSON.parse(res.data.data.signFile);
              signFile.forEach((item) => {
                self.signList.push(item.path);
              });
              console.log(self.imgList);
            }
            if (res.data.data.meetingReport != null) {
              let meetingReport = JSON.parse(res.data.data.meetingReport);
              meetingReport.forEach((item) => {
                self.meetingReport.push(item.path);
              });
            }
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    /** 会议照片 上传相关 开始*/
    handleMeetingRemove(file) {
      let self = this;
      self.meetingPhotoList.forEach(function (j, ind) {
        if (j.url == file.url) {
          self.meetingPhotoList.splice(ind, 1);
        }
      });
    },
    uploadMeetingImage(file) {
      let self = this;
      console.log(file.file);
      let formData = new FormData();
      formData.append('image', file.file);
      self.api
        .postImage(self.urlImg, formData)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let item = {
              name: '会议照片',
              url: res.data.data,
            };
            self.meetingPhotoList.push(item);
            self.$message.success('上传成功');
          } else {
            elf.$message.error('上传失败,请重新上传!');
          }
        })
        .catch(() => {
          self.$message('上传失败,请重新上传');
        });
    },
    /** 会议照片 上传相关 结束*/

    /** 签到表 上传相关 开始*/
    handleSignRemove(file) {
      let self = this;
      self.signFileList.forEach(function (j, ind) {
        if (j.url == file.url) {
          self.signFileList.splice(ind, 1);
        }
      });
    },
    uploadSignImage(file) {
      let self = this;
      console.log(file.file);
      let formData = new FormData();
      formData.append('image', file.file);
      self.api
        .postImage(self.urlImg, formData)
        .then((res) => {
          console.log(res);
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let item = {
              name: '签到表',
              url: res.data.data,
            };
            self.signFileList.push(item);
            self.$message.success('上传成功');
          } else {
            elf.$message.error('上传失败,请重新上传!');
          }
        })
        .catch(() => {
          self.$message('上传失败,请重新上传');
        });
    },
    /** 签到表 上传相关 结束*/
    detailModify() {
      if (this.meetingStartState == 3) {
        //会后资料
        this.afterMeetingVisible = true;
        if (this.onlineDetail.meetingPhoto) {
          var meetingPhoto = JSON.parse(this.onlineDetail.meetingPhoto);
          var meetingPhotoList = [];
          meetingPhoto.forEach((item) => {
            meetingPhotoList.push({
              name: '会议照片',
              url: item.path,
            });
          });
          this.meetingPhotoList = meetingPhotoList;
        }
        if (this.onlineDetail.signFile) {
          var signFile = JSON.parse(this.onlineDetail.signFile);
          var signFileList = [];
          signFile.forEach((item) => {
            signFileList.push({
              name: '签到表',
              url: item.path,
            });
          });
          this.signFileList = signFileList;
        }
        this.afterPage.realJoinNum = this.onlineDetail.realJoinNum;
        this.afterPage.videoUrl = this.onlineDetail.videoUrl;
      }
      if (this.meetingStartState == 1 || this.meetingStartState == 2) {
        //会前资料
        this.beforeMeetingVisible = true;
        if (this.onlineDetail.meetingBill) {
          var meetingBill = JSON.parse(this.onlineDetail.meetingBill);
          var meetingBillList = [];
          meetingBill.forEach((item) => {
            meetingBillList.push({
              name: '邀请海报',
              url: item.path,
            });
          });
          this.meetingBillList = meetingBillList;
        }
        if (this.onlineDetail.meetingLogo) {
          var meetingLogo = JSON.parse(this.onlineDetail.meetingLogo);
          var meetingLogoList = [];
          meetingLogo.forEach((item) => {
            meetingLogoList.push({
              name: '会议封面',
              url: item.path,
            });
          });
          this.meetingLogoList = meetingLogoList;
        }
        if (this.onlineDetail.organisationList) {
          this.departmentData = [];
          this.onlineDetail.organisationList.forEach((item) => {
            this.departmentData.push({
              guid: item.organisationGuid,
              organisationName: item.organisationName,
            });
          });
        }
        this.platformList.forEach((item) => {
          if (item.guid == this.beforePage.meetingPlatformGuid) {
            this.meetingPlatformName = item.platformName;
          }
        });

        this.beforePage.meetingUrl = this.onlineDetail.meetingUrl;
        this.beforePage.servicePhone = this.onlineDetail.servicePhone;
        this.beforePage.isNeedRegister = this.onlineDetail.isNeedRegister;
        this.beforePage.meetingPlatformGuid = this.onlineDetail.meetingPlatformGuid;
        this.beforePage.meetingPlatformName = this.onlineDetail.meetingPlatformName;
        this.beforePage.meetingNo = this.onlineDetail.meetingNo;
      }
    },
    sureAfterUpdate() {
      this.afterPage.meetingPhoto = [];
      this.afterPage.signFile = [];
      var meetingPhotoList = this.meetingPhotoList;
      var signFileList = this.signFileList;
      var self = this;
      var req = {
        dataType: 2,
        guid: self.$route.query.guid,
        meetingOpenId: JSON.parse(localStorage.userInfo).weChatOpentId,
      };
      if (meetingPhotoList.length != 0) {
        meetingPhotoList.forEach((item, index) => {
          this.afterPage.meetingPhoto.push({
            fileName: `会议照片_` + index,
            path: item.url,
          });
        });
      }
      if (signFileList.length != 0) {
        signFileList.forEach((item, index) => {
          this.afterPage.signFile.push({
            fileName: `签到表_` + index,
            path: item.url,
          });
        });
      }
      if (this.afterPage.meetingPhoto.length != 0) {
        req.meetingPhoto = JSON.stringify(this.afterPage.meetingPhoto);
      } else {
        req.meetingPhoto = '';
      }
      if (this.afterPage.signFile.length != 0) {
        req.signFile = JSON.stringify(this.afterPage.signFile);
      } else {
        req.signFile = '';
      }
      req.videoUrl = this.afterPage.videoUrl;
      req.realJoinNum = this.afterPage.realJoinNum;
      self.fullscreenLoading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/meeting/data/edit-meeting-info`, req).then((res) => {
        self.fullscreenLoading = false;
        self.afterMeetingVisible = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.$message.success('会后资料修改成功！');
          self.getMeetingCaList();
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },

    /** 邀请海报 上传相关 开始*/
    handleBillRemove(file) {
      let self = this;
      self.meetingBillList.forEach(function (j, ind) {
        if (j.url == file.url) {
          self.meetingBillList.splice(ind, 1);
        }
      });
    },
    uploadBillImage(file) {
      let self = this;
      console.log(file.file);
      let formData = new FormData();
      formData.append('image', file.file);
      self.api
        .postImage(self.urlImg, formData)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let item = {
              name: '邀请海报',
              url: res.data.data,
            };
            self.meetingBillList.push(item);
            self.$message.success('上传成功');
          } else {
            elf.$message.error('上传失败,请重新上传!');
          }
        })
        .catch(() => {
          self.$message('上传失败,请重新上传');
        });
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件`);
    },
    /** 会议海报 上传相关 结束*/

    /** 会议封面 上传相关 开始*/
    handleLogoRemove(file) {
      let self = this;
      self.meetingLogoList.forEach(function (j, ind) {
        if (j.url == file.url) {
          self.meetingLogoList.splice(ind, 1);
        }
      });
    },
    uploadLogoImage(file) {
      let self = this;
      console.log(file.file);
      let formData = new FormData();
      formData.append('image', file.file);
      self.api
        .postImage(self.urlImg, formData)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let item = {
              name: '会议封面',
              url: res.data.data,
            };
            self.meetingLogoList.push(item);
            self.$message.success('上传成功');
          } else {
            elf.$message.error('上传失败,请重新上传!');
          }
        })
        .catch(() => {
          self.$message('上传失败,请重新上传');
        });
    },
    /** 会议封面 上传相关 结束*/

    sureBeforeUpdate() {
      this.beforePage.meetingBill = [];
      this.beforePage.meetingLogo = [];
      var meetingBillList = this.meetingBillList;
      var meetingLogoList = this.meetingLogoList;
      var self = this;
      var req = {
        dataType: 1,
        guid: self.$route.query.guid,
        meetingOpenId: JSON.parse(localStorage.userInfo).weChatOpentId,
      };

      if (!this.beforePage.meetingPlatformGuid) {
        self.$message.error('请选择会议平台！');
        return;
      }
      if (!this.beforePage.isNeedRegister) {
        self.$message.error('请选择会议是否需要报名！');
        return;
      }
      if (!this.beforePage.servicePhone) {
        self.$message.error('请输入客服热线！');
        return;
      }
      if (!this.beforePage.meetingNo) {
        self.$message.error('请输入会议编号！');
        return;
      }
      if (!this.beforePage.meetingUrl) {
        self.$message.error('请输入会议链接！');
        return;
      }

      if (meetingBillList.length != 0) {
        meetingBillList.forEach((item, index) => {
          this.beforePage.meetingBill.push({
            fileName: `邀请海报_` + index,
            path: item.url,
          });
        });
      }
      if (meetingLogoList.length != 0) {
        meetingLogoList.forEach((item, index) => {
          this.beforePage.meetingLogo.push({
            fileName: `会议封面_` + index,
            path: item.url,
          });
        });
      }
      if (this.beforePage.meetingBill.length != 0) {
        req.meetingBill = JSON.stringify(this.beforePage.meetingBill);
      }
      if (this.beforePage.meetingLogo.length != 0) {
        req.meetingLogo = JSON.stringify(this.beforePage.meetingLogo);
      }
      req.meetingUrl = this.beforePage.meetingUrl;
      req.servicePhone = this.beforePage.servicePhone;
      req.isNeedRegister = this.beforePage.isNeedRegister;
      req.meetingPlatformGuid = this.beforePage.meetingPlatformGuid;
      req.meetingNo = this.beforePage.meetingNo;
      if (this.departmentData !== '') {
        var departmentData = [];
        self.departmentData.forEach((item) => {
          departmentData.push(item.guid);
        });
        req.organisationGuids = departmentData;
      }
      self.fullscreenLoading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/meeting/data/edit-meeting-info`, req).then((res) => {
        self.fullscreenLoading = false;
        self.beforeMeetingVisible = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.$message.success('会前资料修改成功！');
          self.getMeetingCaList();
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },

    //获取组织
    getOrganisation(guid) {
      let self = this;
      self.api
        .get(
          `/${serverConfig.msPersonnelService}/organisation/data/get-organisation-detail?bizState=Y&tenantGuid=` + guid,
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.areaData = res.data.data;
          } else {
            self.$message.error(res.data.msg);
            self.areaData = [];
            self.tableData = [];
          }
        });
    },
    unique(arr) {
      //Set数据结构，它类似于数组，其成员的值都是唯一的
      return Array.from(new Set(arr)); // 利用Array.from将Set结构转换成数组
    },
    //部门弹框选择
    handleNodeClick1(data) {
      let self = this;
      console.log(data);
      let item = {
        guid: data.guid,
        organisationName: data.organisationName,
      };
      self.area.push(JSON.stringify(item));
      self.area = self.unique(self.area);
      self.departmentList = [];
      self.area.forEach(function (i) {
        self.departmentList.push(JSON.parse(i));
      });
      console.log(self.departmentData);
    },
    //确定选择部门
    departmentSure() {
      this.departmentData = this.departmentList;
      console.log(this.departmentData);
      this.visible3 = false;
    },
    handleSelectionChange1(val) {
      let self = this;
      self.delList = val;
      console.log(val);
    },
    //删除部门
    delDepartment() {
      let self = this;
      if (self.delList == null || self.delList.length == 0) {
        self.$message.error('请勾选部门！');
        return;
      }
      self.delList.forEach(function (j) {
        self.departmentList.forEach(function (i, index) {
          if (i.guid == j.guid) {
            self.departmentList.splice(index, 1);
          }
        });
      });
      self.delList.forEach(function (m) {
        self.area.forEach(function (n, idn) {
          if (JSON.parse(n).guid == m.guid) {
            self.area.splice(idn, 1);
          }
        });
      });
    },
    //删除单个部门
    delDepartmentSingle(index) {
      this.departmentData.splice(index, 1);
      this.departmentList = this.departmentData;
      this.area.splice(index, 1);
      // this.departmentList.splice(index,1)
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.organisationName.indexOf(value) !== -1;
    },
  },
};
</script>
